import React, { Component } from "react";
import { Form as AntdForm } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";

export default class Form extends AntdForm {
  static defaultProps = {
    ...AntdForm.defaultProps,
    layout: "vertical",
  };
}
